import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React from "react";
import { t } from "utilities/localization-utils";

interface DoneButtonProps {
    onDone: any;
}

const CSS_CLASS_NAME = "c-done-button";

const DoneButton = ({ onDone }: DoneButtonProps) => {
    return (
        <Button
            size={ButtonSizes.XSmall}
            cssClassName={CSS_CLASS_NAME}
            style={ButtonStyles.Success}
            onClick={onDone}
            dataTestId="page-block--done-button">
            <Icon type={Icons.Checkmark} />
            {t("done")}
        </Button>
    );
};

export default DoneButton;
